import {NgModule} from '@angular/core';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {NgxLongPress2Module} from 'ngx-long-press2';
import {CustomCameraPageComponent} from './custom-camera-page.component';
import {CustomCameraService} from './custom-camera.service';
import {PrePublishModeComponent} from './pre-publish-mode/pre-publish-mode.component';
import {CommonModule} from '@angular/common';
import {EndCapModule} from '../../shared/end-cap/end-cap.module';
import {PushPipe} from "@ngrx/component";
import {Ripple} from "primeng/ripple";
import {ButtonDirective} from "primeng/button";

@NgModule({
  imports: [
    NgxLongPress2Module,
    NgCircleProgressModule.forRoot({}),
    CommonModule,
    EndCapModule,
    PushPipe,
    Ripple,
    ButtonDirective,
  ],
    providers: [
      CustomCameraService
    ],
    declarations: [CustomCameraPageComponent, PrePublishModeComponent],
    exports: [
        CustomCameraPageComponent
    ]
})
export class CustomCameraPageModule {
}
